import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_2xl,
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};

  .TaskDetails-transactionDetails {
    display: flex;
    flex-direction: column;
    gap: ${spacing(4)};
    padding: ${spacing(5)};
    border-radius: ${spacing(2)};
    border: 1px solid ${base_colorContentBorder};
    background: ${base_colorRaisedSurface};

    .TaskDetails-transactionDetails-title {
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_medium};
      ${font_2xl};
    }

    .TaskDetails-transactionDetails-amount {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      gap: ${spacing(2)};

      .TaskDetails-transactionDetails-amount-value {
        color: ${text_colorTextPrimary};
        font-family: ${font_family_weight_medium};
        ${font_2xl};
      }

      .TaskDetails-transactionDetails-amount-currency {
        color: ${text_colorTextSecondary};
        font-family: ${font_family_weight_regular};
        ${font_md};
      }
    }

    .TaskDetails-transactionDetails-details {
      display: inline-flex;
      flex-direction: row;
      gap: ${spacing(2)};
      align-items: center;
      flex-wrap: wrap;

      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_regular};
      ${font_lg};

      .separator {
        color: ${text_colorTextSecondary};
        font-family: ${font_family_weight_regular};
        ${font_md};
      }

      .TaskDetails-transactionDetails-details-creditCard {
        display: flex;
        flex-direction: row;
        gap: ${spacing(1)};
        align-items: center;
        flex-wrap: wrap;
      }
    }
  }

  .TaskDetails-missingReceipts {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
    padding: ${spacing(5)};
    border-radius: ${spacing(2)};
    border: 1px solid ${base_colorContentBorder};
    background: ${base_colorRaisedSurface};

    .TaskDetails-missingReceipts-title {
      display: flex;
      flex-direction: row;
      gap: ${spacing(2)};
      align-items: center;

      text-align: center;
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_medium};
      ${font_lg};
    }

    .TaskDetails-missingReceipts-noReceipts {
      padding-top: ${spacing(1)};
      font-family: ${font_family_weight_medium};
      ${font_md};
    }

    .TaskDetails-missingReceipts-errorList {
      padding: 0;
      & > * {
        margin: 0;
      }
    }
  }

  .TaskDetails-missingExpCats {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
    padding: ${spacing(5)};
    border-radius: ${spacing(2)};
    border: 1px solid ${base_colorContentBorder};
    background: ${base_colorRaisedSurface};

    .TaskDetails-missingExpCats-title {
      display: flex;
      flex-direction: row;
      gap: ${spacing(2)};
      align-items: center;

      text-align: center;
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_medium};
      ${font_lg};
    }
  }

  .TaskDetails-notes {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
    padding: ${spacing(5)};
    border-radius: ${spacing(2)};
    border: 1px solid ${base_colorContentBorder};
    background: ${base_colorRaisedSurface};

    .TaskDetails-notes-title {
      display: flex;
      flex-direction: row;
      gap: ${spacing(2)};
      align-items: center;

      text-align: center;
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_medium};
      ${font_lg};
    }
  }
`
